// Matches the userBOP.name column and the backend check in updateProfileSettings.
export const PROFILE_NAME_MAX_LENGTH = 255;

// Returns an error message, or "" when the name can be saved.
export const getProfileNameError = (name, currentName = "") => {
  const trimmed = (name || "").trim();
  if (!trimmed) return "Name cannot be empty";
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(trimmed))
    return "Name cannot contain line breaks or control characters";
  if (trimmed.length > PROFILE_NAME_MAX_LENGTH)
    return `Name cannot be longer than ${PROFILE_NAME_MAX_LENGTH} characters`;
  if (trimmed === (currentName || "").trim()) return "Name is unchanged";
  return "";
};
